import { schema } from "normalizr";

const projectTemplate = new schema.Entity(`projectTemplates`);
const arrayOfProjectTemplates = [projectTemplate];

export { projectTemplate, arrayOfProjectTemplates };
